module.exports = __webpack_public_path__ + "static/media/profile-2.9d0a3b35.png";